







import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ components: {} })
export default class chat_header extends Vue {
  @Prop({ type: Boolean, default: false }) public showToggle!: boolean;
  @Prop({ type: String, default: "Asesor BMC/VP" }) public title!: string;
}
